import Skeleton from "react-loading-skeleton";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import { ProfileField } from "@/portals/(shared)/(profile)/components/ProfileField";
import { usePracticeList } from "@/portals/(admin)/(practice)/api/queries/usePracticeList";

export function AssociatedPracticeCard() {
  const { data: practiceList, isLoading } = usePracticeList();

  return (
    <DashboardCard2 title="Associated Practice">
      {isLoading ? (
        <AssociatedPracticeSkeleton />
      ) : (
        <div className="tw:grid tw:grid-cols-1 tw:gap-x-4 tw:gap-y-2 tw:md:grid-cols-2">
          {practiceList?.map((item, index) => (
            <ProfileField key={item.name + index} title={item.name} value={item.general_email} />
          ))}
        </div>
      )}
    </DashboardCard2>
  );
}

function AssociatedPracticeSkeleton() {
  return (
    <div className="tw:grid tw:grid-cols-1 tw:gap-x-4 tw:gap-y-1 tw:md:grid-cols-2">
      {Array.from({ length: 6 }).map((_, i) => (
        <div className="tw:mb-4 tw:flex tw:flex-col tw:gap-2 tw:leading-none" key={i}>
          <Skeleton height={14} width={180} />
          <Skeleton height={12} width={320} />
        </div>
      ))}
    </div>
  );
}
